<template>
    <el-dialog class="el-dialogs" title="评审建议" :append-to-body="true" width="500px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" class="query-form" ref="searchForm" :model="searchForm" :rules="rules"
                 label-position="top" @keyup.enter.native="doSubmit()" label-width="80px">
            <el-form-item label="请填写评审建议" prop="processOpinion">
                <el-input
                        type="textarea"
                        :rows="5" resize="none"
                        maxlength="100"
                        placeholder="请输入内容(限100字)"
                        v-model="searchForm.processOpinion">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "setToexamine",
    data() {
        return {
            visible: false,
            searchForm: {
                processOpinion: '',
            },
            rules: {},
            type: '',
            url:'',
            ids:[],
            others:{},
        }
    },

    methods: {
        //type through通过 reject驳回
        //url请求地址
        //others 其它参数（通过、驳回等）{}
        init(ids, type,url,others) {
            this.visible = true
            this.type = type
            this.url = url
            this.ids = ids
            this.others = others
            this.rules = {}
            if (this.type == 'reject') {
                let processOpinion = [
                    {required: true, message: '请填写评审建议', trigger: 'blur'}
                ]
                this.$set(this.rules, 'processOpinion', processOpinion)
            }
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
        },

        //确定
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.$axios(this.url, {
                        ...this.searchForm,
                        ids:this.ids,
                        ...this.others,
                    }, 'post').then(data => {
                        if (data && data.status) {
                            this.$message.success(`${this.type == 'reject' ? '驳回' : '通过'}成功`)
                            this.$emit('refresh')
                            this.visible = false
                            //更新我的未读信息
                            this.$store.commit('user/updateUserMessage')
                        } else {
                            this.$message.error(data.msg)
                            this.$emit('refresh')
                            this.visible = false
                        }
                    })
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>